<div class="content-info">
  <div class="content-title d-flex flex-column flex-md-row align-items-md-center justify-content-between">
    <h3 class="title mb-3 mb-md-0">Picklist</h3>
    <div class="title-actions d-flex flex-wrap align-items-center gap-2">
      <!-- Search Picklist input -->
      <div class="form-group mb-0">
        <input type="text" class="form-control" placeholder="Search by Picklist No" [(ngModel)]="searchQuery"
          (input)="onSearch()" style="min-width: 200px;" />
      </div>

      <!-- Create Picklist button -->
      <button class="btn btnprimary text-nowrap" type="button" (click)="onCreatePicklist()">
        <i class="bi bi-plus-lg"></i>
        Create Picklist
      </button>
    </div>
  </div>

  <div class="common-table mt-3">
    <div class="table-responsive" style="max-height: 65vh; overflow-y: auto; overflow-x: auto;">
      <table class="table align-middle">
        <thead>
          <tr>
            <th class="text-start text-nowrap">Picklist No</th>
            <th class="text-start text-nowrap">GRN No</th>
            <th class="text-start text-nowrap">Status</th>
            <th class="text-end text-nowrap">Total Qty</th>
            <th class="text-end text-nowrap">Items Count</th>
            <th class="text-start text-nowrap">Created Date</th>
            <th class="text-end text-nowrap">Action</th>
          </tr>
        </thead>
        <tbody>
          @for (pick of picklist; track pick) {
          <tr>
            <td class="text-start text-nowrap">
              <a [routerLink]="['/picklist', pick.id]" [queryParams]="{ view: true }" class="text-decoration-none">
                {{ pick.picklistNumber }}
              </a>
            </td>
            <td class="text-start text-nowrap">{{ pick.grnNumber }}</td>
            <td>
              <span class="badge" [ngClass]="
                  pick.status === 'POSTED' ? 'bg-success' : 'bg-warning'
                ">
                {{ pick.status }}
              </span>
            </td>
            <td class="text-end text-nowrap">{{ pick.totalQty }}</td>
            <td class="text-end text-nowrap">{{ pick.itemsCount }}</td>
            <td class="text-start text-nowrap">
              {{ pick.createdAt | date : "dd/MM/yyyy HH:mm" }}
            </td>
            <td class="text-end text-nowrap">
              <a role="button" (click)="downloadPdf(pick.id)" class="text-success me-3 d-inline-block"
                title="Download PDF">
                <i class="bi bi-file-earmark-arrow-down"></i>
              </a>

              @if (pick.status === 'DRAFT') {
              <a [routerLink]="['/picklist/edit', pick.id, pick.grnNumber]">
                <i class="bi bi-pencil-square text-primary"></i>
              </a>
              } @else {
              <a [routerLink]="['/picklist/', pick.id]" [queryParams]="{ view: 'true' }">
                <i class="bi bi-eye text-info"></i>
              </a>
              }
            </td>
          </tr>
          } @if (picklist.length === 0) {
          <tr>
            <td colspan="6" class="text-center text-muted">No records found</td>
          </tr>
          }
        </tbody>
      </table>
    </div>

    <div class="table-pagination d-flex justify-content-between align-items-center mt-2">
      <div class="pagination-count">
        <select [(ngModel)]="pageSize" (change)="pageSizeChange()">
          @for (size of [10, 20, 30, 40]; track size) {
          <option [value]="size">
            {{ size }}
          </option>
          }
        </select>
        <span class="ms-1">entries per page</span>
      </div>
      <ul class="pagination mb-0">
        <!-- Previous button -->
        <li class="page-item" [class.disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)">
          <a class="page-link">&laquo;</a>
        </li>

        <!-- First Page button -->
        <li class="page-item" [class.active]="currentPage === 1" (click)="goToPage(1)">
          <a class="page-link">1</a>
        </li>

        <!-- Left Ellipsis -->
        @if (currentPage > 4) {
        <li class="page-item disabled">
          <a class="page-link">...</a>
        </li>
        }

        <!-- Pages Around Current page -->
        @for (page of getVisiblePages(); track page) {
        <li class="page-item" [class.active]="page === currentPage" (click)="goToPage(page)">
          <a class="page-link">{{ page }}</a>
        </li>
        }

        <!-- Right Ellipsis -->
        @if (currentPage < pageCount - 3) { <li class="page-item disabled">
          <a class="page-link">...</a>
          </li>
          }

          <!-- Last Page button - only show if more than 1 page -->
          @if (pageCount > 1) {
          <li class="page-item" [class.active]="currentPage === pageCount" (click)="goToPage(pageCount)">
            <a class="page-link">{{ pageCount }}</a>
          </li>
          }

          <!-- Next button -->
          <li class="page-item" [class.disabled]="currentPage === pageCount" (click)="goToPage(currentPage + 1)">
            <a class="page-link">&raquo;</a>
          </li>
      </ul>
    </div>
  </div>
</div>

<div class="modal fade" id="confirmPickModal" tabindex="-1" aria-labelledby="confirmPickModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-sm">
    <div class="modal-content">
      <div class="modal-header border-bottom-0">
        <h5 class="modal-title fw-bold" id="confirmPickModalLabel">
          Generate Picklist PO?
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body text-center p-4">
        <i class="bi bi-question-circle text-primary fs-1 mb-3"></i>
        <p class="text-dark fw-semibold">
          You are about to generate
          <strong class="text-primary">Draft Purchase Orders</strong>
        </p>
        <p class="text-muted small mb-0">Are you sure you want to proceed?</p>
      </div>
      <div class="modal-footer border-top-0 d-flex">
        <button type="button" class="btn btn-secondary w-50" data-bs-dismiss="modal">
          Cancel
        </button>
        <button type="button" class="btn btnprimary w-50" [disabled]="loading">
          @if (loading) {
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          } @if (!loading) {
          <span>Generate</span>
          }
        </button>
      </div>
    </div>
  </div>
</div>